import { Howl, Howler } from "howler";

export const makeSound = (id, audioAlphabet, value) => {
  const sound = new Howl({
    src: audioAlphabet[id],
    html5: true,
  });
  sound.play();
  Howler.volume(0.9);
};

// Check on which device is launched mobile/desktop
export const getMediaQuery = (media) =>
  Object.entries(media).filter((el) => el[1] === true)[0];
